/** @type {Styles} */

export const styles = {
  checkbox: {
    width: 'fit-content',
    '&:not(.Mui-checked):not(.Mui-disabled):not(.MuiCheckbox-indeterminate) > .MuiSvgIcon-root	': {
      color: 'gray.40',
      height: 24,
      width: 24,
    },
    '&.Mui-disabled .MuiSvgIcon-root': {
      color: 'gray.16',
    },
    '& .MuiSvgIcon-root': {
      height: 24,
      width: 24,
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },

  label: {
    display: 'flex',
    color: 'gray.80',

    '&.MuiFormControlLabel-labelPlacementStart': {
      justifyContent: 'space-between',
      paddingLeft: 2.5,
    },
    '.MuiFormControlLabel-label': { typography: 'medium' },
  },

  labelSelected: {
    color: 'primary.main',
    '&.MuiTypography-small': {
      color: 'primary.main',
    },
    '.MuiFormControlLabel-label': {
      fontWeight: 600,
    },
  },
  labelDisabled: {
    color: 'gray.40',
    '&.MuiTypography-small': {
      color: 'gray.40',
    },
    '.MuiFormControlLabel-label': {
      fontWeight: 400,
    },
  },
  labelWrapper: {
    alignItems: 'center',
  },
  searchContainer: {
    '.MuiTextField-root': {
      borderRadius: 1,
    },
  },
  searchInput: {
    backgroundColor: 'gray.3',
    '.MuiOutlinedInput-notchedOutline': {
      border: 0,
      borderRadius: 0,
    },
    '.MuiOutlinedInput-input': {
      paddingY: 1.25,
    },
    '.MuiOutlinedInput-root': {
      paddingLeft: 1,
    },
  },
  optionsContainer: {
    borderRadius: 2,
    borderStyle: 'solid',
    borderColor: 'gray.12',
    borderWidth: 1,
    padding: 2.75,
    marginTop: 2,
  },
  switch: {
    '.MuiFormControlLabel-root': {
      marginRight: 1,
    },
  },
  scroller: {
    overflow: 'overlay',
    height: '50vh',
    scrollbarColor: 'gray.3',
    '::-webkit-scrollbar': {
      width: '4px',
    },
    '::-webkit-scrollbar-thumb': {
      background: 'gray.8',
    },
  },
  buttonOptions: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 2,
  },
  hasDividerStyles: {
    marginY: 1,
    borderColor: 'gray.12',
    marginLeft: -4,
    marginRight: 0,
    overflow: 'visible',
    '&:last-child': {
      border: 'none',
    },
  },
  divider: {
    width: '100%',
    marginY: 1,
    borderColor: 'gray.12',
  },
  noRenderContainer: {
    height: '50vh',
    display: 'grid',
    placeItems: 'center',
  },
  noRenderSubContainer: {
    display: 'grid',
    placeItems: 'center',
  },
}
